import BodyText from 'LuxKit/Typography/BodyText'
import { useIntl } from 'react-intl'
import useExperienceSearch from 'hooks/Experiences/useExperienceSearch'
import ExperienceListTileCarousel from './ExperienceListTileCarousel'
import { useAppSelector } from 'hooks/reduxHooks'
import { getOptimizelyFeatureFlagVariation } from 'lib/optimizely/optimizelyUtils'
import { OptimizelyFeatureFlags } from 'constants/featureFlags'

interface Props {
  placeId: string
  placeIdToIgnore?: string
  categories?: Array<number>
  sortBy?: Experiences.SortTypes
  excludeIds?: Array<string>
  className?: string
  limit?: number
  campaigns?: Array<string>
  collections?: Array<string>
}

function ExperienceSearchTileList(props: Props) {
  const { placeId, placeIdToIgnore, categories, sortBy, excludeIds, className, limit = 20, campaigns, collections } = props
  const intl = useIntl()

  const randomizeExperiencesOffersEnabled = useAppSelector(state => getOptimizelyFeatureFlagVariation(state, OptimizelyFeatureFlags.randomizeExperiencesOffers))

  const [list, experiences] = useExperienceSearch({
    placeId,
    placeIdToIgnore,
    sortBy,
    limit,
    excludeIds,
    campaigns,
    randomize: randomizeExperiencesOffersEnabled,
  }, { categoryCodes: categories, collections })

  const fetching = (!list || list.fetching) && !list?.error

  return <div>
    {list?.error && <BodyText variant="large">{intl.formatMessage({
      id: '0b-Wid5FhminQdg3Xfzl',
      defaultMessage: 'Something went wrong!',
      description: 'Error message when experience search tile list fails to load',
    })}
    </BodyText>}
    {!fetching && !list?.error && list.ids.length === 0 && <BodyText variant="large">
      {intl.formatMessage({
        id: 'So_JlvmSpy9FowOQ7NHB',
        defaultMessage: 'No experiences available',
        description: 'Empty state message when no experiences are found in tile list',
      })}
    </BodyText>}
    <ExperienceListTileCarousel
      className={className}
      experiences={experiences}
      listFetching={fetching}
      listKey={list.listKey}
    />
  </div>
}

export default ExperienceSearchTileList
